import { useGateValue } from '@statsig/react-bindings';

/**
 * Returns whether RBAC enforcement is enabled via the Statsig `enable_rbac` gate.
 */
export function useRbacEnabled(): boolean {
  return useGateValue('enable_rbac');
}
